// Angular imports
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Rxjs imports
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';

// Constant imports
import { URLConstants } from '../../../../_constants/url-constants';

// Model imports
import { APCreditApplicationEditorParameterDto } from '../../_models/accounts-payable/apply-debit/ap-credit-application-editor-parameter-dto';
import { APCreditApplicationEditorResultDto } from '../../_models/accounts-payable/apply-debit/ap-credit-application-editor-result-dto';
import { APApplyDebitParametersDto } from '../../_models/accounts-payable/apply-debit/ap-apply-debit-parameters-dto';

@Injectable({
    providedIn: 'root'
})
export class ApplyAdjustmentDebitService {
    constructor(private readonly httpClient: HttpClient) {}

    getApplyDebitEditorData(
        baseParams: APCreditApplicationEditorParameterDto
    ): Observable<APCreditApplicationEditorResultDto> {
        const url = `${URLConstants.ccCBAPAdjustmentApiUrl}/applydebit/editor`;
        return this.httpClient
            .post(url, classToPlain(baseParams))
            .pipe(
                map((response: APCreditApplicationEditorResultDto) =>
                    plainToClass(APCreditApplicationEditorResultDto, response)
                )
            );
    }

    applyDebitToAdjustment(baseParams: APApplyDebitParametersDto): Observable<any> {
        const url = `${URLConstants.ccCBAPAdjustmentApiUrl}/applydebit`;
        return this.httpClient.post(url, classToPlain(baseParams));
    }
}
